module.exports = __webpack_public_path__ + "img/9788925558172.6de29608.jpg";